import React, { Component } from 'react'

import { QuickFilterBlock, QuickFilterBlockSelected } from './PresetFilters.styles'
import { Icon } from '../../../../shared/tr-icons'

class QuickFilterContainer extends Component {
  handleClick = (evt) => {
    evt.preventDefault()

    this.props.analytics.propagateEvent({
      eventType: 'click',
      action: 'Apply Quick Filter',
      type: 'Datatable'
    })

    this.props.handleApply(this.props.content, this.props.uuid, this.props.title)
  }

  render() {
    if (this.props.applied === this.props.uuid) {
      return (
        <QuickFilterBlockSelected onClick={this.handleClick}>
          <Icon type='tick' />
          {this.props.title}
        </QuickFilterBlockSelected>
      )
    }

    return (
      <QuickFilterBlock onClick={this.handleClick}>
        <Icon type='filter' />
        {this.props.title}
      </QuickFilterBlock>
    )
  }
}

export default QuickFilterContainer
